import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

import { ref, reactive, unref, onMounted, watch } from 'vue';

/* NPM Plugins */
import { FormRules, ElForm } from 'element-plus';
import { GetErpSupplierApi, GetErpCustomApi } from '../../../apis/counterpart/counterpart.api';


interface formModel {
    original_type: string
    original_no: string
    original_name: string
    new_type: string
    new_type_id: string
    new_no: string
}


export default /*#__PURE__*/_defineComponent({
  emits: ['register'],
  setup(__props, { expose, emit: $emits }) {



const formRules = reactive<FormRules>({
    new_type_id: [
        { required: true, message: '新类型不能留空', trigger: 'blur' },
    ],
    new_no: [
        { required: true, message: '新编号不能留空', trigger: 'blur' },
    ],
})

const loading = ref<boolean>(false)
const searchLoading = ref<boolean>(false)

const customlist = ref<any[]>([])
const asnycData = ref({})

const elFormRef = ref<ComponentRef<typeof ElForm>>()

const formSchema = ref<formModel>({
    original_type: '',
    original_no: '',
    original_name: '',
    new_type: '',
    new_type_id: '2',
    new_no: '',
});

const funcs = {

    getLoadStatus: (): boolean => { return unref(loading) },

    /* 设置读取状态 */
    setLoadStatus: (isLoad: boolean) => { loading.value = isLoad },

    /* 获取表单数据 */
    getData: () => {

        return unref(asnycData);

    },

    /* 设置表单数据 */
    setFormData: (data: any): void => {

        formSchema.value = Object.assign(unref(formSchema), data)

    }

}

/* 读取供应商/客户列表数据 */
const remoteMethod = (val: string) => {

    if (val.length < 2) return

    searchLoading.value = true

    /* 供应商 */
    if (unref(formSchema).new_type_id == "2") {

        GetErpSupplierApi(val).then(res => {

            customlist.value = res.data

        }).finally(() => { searchLoading.value = false })
    }

    /* 客户 */
    if (unref(formSchema).new_type_id == "3") {

        GetErpCustomApi(val).then(res => {

            customlist.value = res.data

        }).finally(() => { searchLoading.value = false })
    }

}

/* 选中值 */
const onSelectChange = (item: any) => {

    /* 供应商 */
    if (unref(formSchema).new_type_id == "2") {

        unref(formSchema).new_no = item.venno

        unref(asnycData)['no'] = item.venno
        unref(asnycData)['name'] = item.vensname
        unref(asnycData)['short_name'] = item.shortname
        unref(asnycData)['address'] = item.cadd
        unref(asnycData)['code'] = item.business_license
        unref(asnycData)['contract'] = item.leal_person
        unref(asnycData)['contract_num'] = item.mobil
        unref(asnycData)['invoice_title'] = item.invoice_name
        unref(asnycData)['invoice_address'] = item.invoice_address

        unref(asnycData)['part_type_id'] = '2'
        unref(asnycData)['original_no'] = unref(formSchema).original_no


    }

    /* 客户 */
    if (unref(formSchema).new_type_id == "3") {

        unref(formSchema).new_no = item.custno

        unref(asnycData)['no'] = item.custno
        unref(asnycData)['name'] = item.custsname
        unref(asnycData)['short_name'] = item.shortname
        unref(asnycData)['code'] = item.business_license
        unref(asnycData)['contract'] = item.leal_person
        unref(asnycData)['contract_num'] = item.tel
        unref(asnycData)['invoice_title'] = item.invoice_name
        unref(asnycData)['invoice_address'] = item.invoice_address

        unref(asnycData)['part_type_id'] = '3'
        unref(asnycData)['original_no'] = unref(formSchema).original_no
    }

}

expose({ funcs })

onMounted(() => {
    $emits('register', unref(elFormRef)?.$parent, unref(elFormRef))
})


return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createBlock(_unref(ElForm), {
    ref_key: "elFormRef",
    ref: elFormRef,
    model: formSchema.value,
    "label-width": "150px",
    "label-position": 'right',
    rules: _unref(formRules)
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_form_item, { label: "相对方名称" }, {
        default: _withCtx(() => [
          _createVNode(_component_el_input, {
            modelValue: formSchema.value.original_name,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formSchema.value.original_name) = $event)),
            disabled: ""
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_form_item, { label: "原编号" }, {
        default: _withCtx(() => [
          _createVNode(_component_el_input, {
            modelValue: formSchema.value.original_no,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formSchema.value.original_no) = $event)),
            disabled: ""
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_form_item, { label: "原类型" }, {
        default: _withCtx(() => [
          _createVNode(_component_el_input, {
            modelValue: formSchema.value.original_type,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formSchema.value.original_type) = $event)),
            disabled: ""
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_form_item, {
        label: "新类型",
        prop: "new_type_id"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_select, {
            style: {"width":"100%"},
            modelValue: formSchema.value.new_type_id,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formSchema.value.new_type_id) = $event)),
            placeholder: "请选择相对方类型",
            onChange: _cache[4] || (_cache[4] = ($event: any) => ( customlist.value = []))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_option, {
                label: "供应商",
                value: "2"
              }),
              _createVNode(_component_el_option, {
                label: "客户",
                value: "3"
              })
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_form_item, {
        label: "新编号",
        prop: "new_no"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_select, {
            style: {"width":"100%"},
            modelValue: formSchema.value.new_no,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formSchema.value.new_no) = $event)),
            filterable: "",
            remote: "",
            "reserve-keyword": "",
            "remote-show-suffix": "",
            loading: searchLoading.value,
            placeholder: "请输入名称或编号进行搜索，需要2个(含)字符以上",
            "remote-method": remoteMethod,
            onChange: onSelectChange
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(customlist.value, (item, idx) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: idx,
                  label: item.vensname || item.custsname,
                  value: item
                }, null, 8, ["label", "value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue", "loading"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["model", "rules"])), [
    [_directive_loading, loading.value]
  ])
}
}

})